export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7877.97d15d55.jpg";